import { stringify } from 'qs';
import request from '../utils/request';
import local from '../utils/local';
export async function getList(params) {
    return request(`/?${stringify(params)}`);
}

export async function get(id, params = {}) {
    return request(`//${id}`, { params });
}

export async function create(body) {
    return request(`/`, {
        method: 'POST',
        body,
    });
}

export async function update(id, body) {
    return request(`//${id}`, {
        method: 'POST',
        body,
    });
}
export async function voucherCheckouts(body) {
    const formData = new FormData()
    formData.append("file", body.file)
    try {
        return request(`/voucher/vouchers-checkouts `, {
            method: 'POST',
            headers: {
                // "Content-Type": "multipart/form-data",
                "Accept": body.file.type,
                'X-Access-Token': local.get('token')
            },
            body: formData,
        });
    } catch (error) {
        console.log("error:",error)
    }
    
}